import * as React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from "../../../../actions";
import RecapComponent from "./recap-component";
import LocalAuthority from "../../../../model/local-authority";
import Rest from "../../../../model/rest";
import RestsService from "../../../../service/sfp/rests-service";
import Result from "../../../../model/result";
import ResultsService from "../../../../service/sfp/results-service";

const ROW_ID_INVESTMENT_RESULT = "INVESTMENT_RESULT";
const ROW_ID_PREVIOUS_RESULT = "PREVIOUS_RESULT";

class RecapContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { data: [], loading: props.loading };
  }

  componentDidMount() {
    this._setData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this._setData(nextProps);
  }

  render() {
    const data = this.state.data;

    return (
      <RecapComponent
        loading={this.props.loading}
        singled={this.props.singled}
        years={this.props.years}
        data={data}
        focusedCell={this.state.focusedCell}
        onCellPressDown={this._saveRestAndFocus}
        onCellPressUp={this._saveRestAndFocus}
        onCellPressEnter={this._saveRestAndFocus}
        onCellPressLeft={this._saveRestAndFocus}
        onCellPressRight={this._saveRestAndFocus}
        onCellPressEscape={this._handleCellPressEscape}
        onCellPressShiftTab={this._saveRestAndFocus}
        onCellPressTab={this._saveRestAndFocus}
      />
    );
  }

  _setData = (props) => {
    const data = props.currentLocalAuthority
      ? this._getData(
          props.currentLocalAuthority,
          props.dataInvestReceipts,
          props.dataInvestExpense,
          props.receipts,
          props.years
        )
      : [];

    this.setState({ data, loading: props.loading });
  };

  _getData = (
    /** @type {LocalAuthority} */ localAuthority,
    /** @type {Object[]} */ dataInvestReceipts,
    /** @type {Object[]} */ dataInvestExpense,
    /** @type {Boolean} */ receipt,
    /** @type {Number[]} */ years
  ) => {
    let obj = { label: null };
    let listOperationOrderReceipt = this._getOrderOperation(
      localAuthority.accounts,
      localAuthority.observations,
      false,
      true,
      years
    );
    let listOperationOrderExpense = this._getOrderOperation(
      localAuthority.accounts,
      localAuthority.observations,
      false,
      false,
      years
    );
    let totalOpeOrdreReceipt = listOperationOrderReceipt.find(
      (op) => "orderoperation" === op.id
    );
    let totalOpeOrdreExpense = listOperationOrderExpense.find(
      (op) => "orderoperation" === op.id
    );
    let tab = [];
    years.forEach((y) => {
      obj[y.toString()] = _.sumBy(dataInvestReceipts, (row) => {
        if (
          (row.id && row.id === "receiptsEquipment") ||
          (row.label && row.label === "Non chapitrés") ||
          (row.id && row.id === "receiptsFinancial")
        )
          return row[y.toString()];
      });
      obj[y.toString()] += totalOpeOrdreReceipt[y.toString()];
    });
    obj.label = "Total recette investissement";
    tab.push(obj);
    obj = {};

    years.forEach((y) => {
      obj[y.toString()] = _.sumBy(dataInvestExpense, (row) => {
        if (
          (row.id && row.id === "expenseEquipment") ||
          (row.label && row.label === "expenseFinancial") ||
          (row.label && row.label === "Opérations d'ordre")
        )
          return row[y.toString()];
      });
      obj[y.toString()] += totalOpeOrdreExpense[y.toString()];
    });
    obj.label = "Total dépense investissement";
    tab.push(obj);
    obj = {};

    years.forEach((y) => {
      const resYearMinus1 = _.find(
        localAuthority.results,
        (r) => r.year === y - 1 && r.operation === false
      );
      if (undefined === resYearMinus1) {
        obj[y.toString()] = undefined;
      } else {
        resYearMinus1.loading = false;
        obj[y.toString()] = resYearMinus1;
      }
    });
    obj.rowId = ROW_ID_PREVIOUS_RESULT;
    obj.label = "Résultat N-1";
    tab.push(obj);
    obj = {};

    years.forEach((y) => {
      let valueY = undefined;
      if (undefined != tab[2][y.toString()]) valueY = tab[2][y.toString()];
      obj[y.toString()] = _.round(
        tab[0][y.toString()] - tab[1][y.toString()],
        2
      );
      if (undefined != valueY)
        obj[y.toString()] = obj[y.toString()] + valueY.amount;
    });
    obj.rowId = ROW_ID_INVESTMENT_RESULT;
    obj.label = "Résultat section investissement";
    tab.push(obj);
    obj = {};

    years.forEach((y) => {
      const restToDoReceipt = _.find(
        localAuthority.rests,
        (r) => r.year === y && r.receipt === true
      );
      if (undefined === restToDoReceipt) {
        obj[y.toString()] = undefined;
      } else {
        restToDoReceipt.loading = false;
        obj[y.toString()] = restToDoReceipt;
      }
    });
    obj.label = "Reste à réaliser recettes d'investissement";
    tab.push(obj);
    obj = {};

    years.forEach((y) => {
      const restToDoExpense = _.find(
        localAuthority.rests,
        (r) => r.year === y && r.receipt === false
      );
      if (undefined === restToDoExpense) {
        obj[y.toString()] = undefined;
      } else {
        restToDoExpense.loading = false;
        obj[y.toString()] = restToDoExpense;
      }
    });
    obj.label = "Reste à réaliser depenses d'investissement";
    tab.push(obj);

    return tab;
  };

  _createRest = (
    /** @type {Rest} */ rest,
    /** @type {Number} */ index,
    /** @type {String} */ column,
    /** @type {Number} */ oldAmount
  ) => {
    RestsService.createRest(this.props.currentLocalAuthority, rest).then(
      this._updateCellRest.bind(this, index, column, rest),
      this._rejectSaveRest.bind(this, rest, index, column, oldAmount)
    );
  };

  _deleteRest = (
    /** @type {Rest} */ rest,
    /** @type {Number} */ index,
    /** @type {String} */ column,
    /** @type {Number} */ oldAmount
  ) => {
    RestsService.deleteRest(this.props.currentLocalAuthority, rest).then(
      this._removeCellContent.bind(this, index, column),
      this._rejectSaveRest.bind(this, rest, index, column, oldAmount)
    );
  };

  _getOrderOperation = (
    /** @type {Account[]} */ accounts,
    /** @type {Observation[]} */ observations,
    /** @type {Boolean} */ operation,
    /** @type {Boolean} */ receipts,
    /** @type {Number[]} */ years
  ) => {
    let listChapter = [];
    let orderOperationTotal = {
      id: "orderoperation",
      label: "Opération d'ordre",
    };

    // On filtre les accounts afin d'avoir uniquement les comptes d'opération d'ordre
    let filteredArranged = accounts.filter(
      (laca) =>
        laca.account &&
        laca.account.operation === operation &&
        laca.account.receipts === receipts &&
        laca.chapter &&
        _.some(
          laca.chapter.types,
          (type) => type && type.operationType.id === "ORDER"
        ) &&
        laca.chapter.number.startsWith("0")
    );

    // Initialisation de l'objet orderOperationTotal afin de +=
    this._initializeValues(orderOperationTotal, years);

    // On ajoute chaque chapitre qu'une seule fois à une liste -> listChapter
    filteredArranged.forEach((fa) => {
      if (
        !_.some(listChapter, (ch) => ch.chapter.number === fa.chapter.number)
      ) {
        listChapter.push({
          chapter: fa.chapter,
          account: fa.account,
          label: fa.chapter.label,
        });
      }
    });

    // On map les lignes de data avec les infos des lignes de listChapter
    const data = listChapter.map((info) => {
      const row = { info };
      // Pour chaque année on filtre les nouvelles observations par rapport à y, receipts, operation
      years.forEach((y) => {
        const obs = _.filter(observations, (/** @type {Observation}*/ o) => {
          const obsIndexedAccount = _.find(
            filteredArranged,
            (c) => o.account.id === c.account.id
          );
          const isSameYear = o.year === y;
          const isSameReceipts = o.account.receipts === receipts;
          const isSameOperation = o.account.operation === operation;
          return (
            obsIndexedAccount &&
            obsIndexedAccount.chapter &&
            obsIndexedAccount.chapter.id === info.chapter.id &&
            isSameYear &&
            isSameReceipts &&
            isSameOperation
          );
        });
        row[y] = _.round(
          _.sumBy(obs, (o) => o.amount),
          2
        );
        orderOperationTotal[y.toString()] += row[y.toString()];
      });
      row.isCurrency = true;
      row.label = info.chapter.label;
      return row;
    });
    orderOperationTotal.isCurrency = true;
    orderOperationTotal.isTitle = true;
    data.push(orderOperationTotal);
    return data;
  };

  _handleCellPressEscape = (
    /** @type {Number} */ index,
    /** @type {String} */ column,
    /** @type {Rest} */ rest,
    /** @type {SyntheticEvent} */ event
  ) => {
    event.preventDefault();
    const data = this.state.data;
    data[index][column] = result;
    this.setState({ tableResYears: data, focusedCell: null });
  };

  _rejectSaveRest = (
    /** @type {Rest} */ rest,
    /** @type {Number} */ index,
    /** @type {Number} */ column,
    /** @type {Number} */ oldAmount,
    /** @type {Error} */ error
  ) => {
    rest.amount = oldAmount;
    this._updateCellRest(index, column, rest);
    this.props.actions.throwError(error);
  };

  _removeCellContent = (
    /** @type {Number} */ index,
    /** @type {String} */ column
  ) => {
    const data = this.state.data;
    data[index][column] = undefined;
    this.setState({ data });
  };

  _saveResult = (
    /** @type {Number} */ index,
    /** @type {String} */ column,
    /** @type {Result} */ result,
    /** @type {Number} */ amount,
    /** @type {Number} */ oldAmount
  ) => {
    if ((result && result.amount == amount) || (!result && 0 == amount)) return;

    const floatAmount = parseFloat(amount);
    const data = this.state.data;
    data[index][column] = data[index][column] || {};
    data[index][column]["loading"] = true;
    data[index][column]["amount"] = floatAmount;

    this.setState({ data, focusedCell: { index, column } });

    let newResult;

    if (result) {
      if (0 === amount || undefined === amount) {
        result.amount = amount;
        this._deleteResult(result, index, column, oldAmount);
      } else {
        result.amount = amount;
        this._updateResult(result, index, column, oldAmount);
      }
    } else {
      newResult = new Result(
        this.props.currentLocalAuthority,
        false,
        floatAmount,
        parseFloat(column) - 1
      );
      this._createResult(newResult, index, column, oldAmount);
    }
  };

  _saveRest = (
    /** @type {Number} */ index,
    /** @type {String} */ column,
    /** @type {Rest} */ rest,
    /** @type {Number} */ amount,
    /** @type {Number} */ oldAmount
  ) => {
    if ((rest && rest.amount == amount) || (!rest && 0 == amount)) return;

    const data = this.state.data;
    data[index][column] = data[index][column] || {};
    data[index][column]["loading"] = true;
    data[index][column]["amount"] = amount;
    this.setState({ tableResYears: data, focusedCell: { index, column } });

    let receiptValue;
    switch (index) {
      case 2:
        receiptValue = null;
        break;
      case 4:
        receiptValue = true;
        break;
      case 5:
        receiptValue = false;
        break;
    }

    let newRest;

    if (rest) {
      if (amount) {
        rest.amount = amount;
        this._updateRest(rest, index, column, oldAmount);
      } else {
        rest.amount = 0;
        this._deleteRest(rest, index, column, oldAmount);
      }
    } else {
      newRest = new Rest(
        this.props.currentLocalAuthority,
        receiptValue,
        parseInt(amount),
        parseInt(column)
      );
      this._createRest(newRest, index, column, oldAmount);
    }
  };

  _saveRestAndEscape = (
    /** @type {Number} */ index,
    /** @type {String} */ column,
    /** @type {Rest} */ rest,
    /** @type {Number} */ year,
    /** @type {Number} */ amount,
    /** @type {Number} */ oldAmount,
    /** @type {SyntheticEvent} */ event
  ) => {
    event.preventDefault();
    this.setState({ focusedCell: null });
    this._saveRest(index, column, rest, amount, oldAmount);
  };

  _saveRestAndFocus = (
    /** @type {Number} */ index,
    /** @type {String} */ column,
    /** @type {Rest} */ rest,
    /** @type {Number} */ viewIndex,
    /** @type {Number} */ year,
    /** @type {Number} */ amount,
    /** @type {Number} */ oldAmount,
    /** @type {SyntheticEvent} */ event
  ) => {
    event.preventDefault();
    amount = parseFloat(amount);
    switch (index) {
      case 2:
        this._saveResult(index, column, rest, amount, oldAmount);
        break;
      case 4:
      case 5:
        this._saveRest(index, column, rest, amount, oldAmount);
    }
  };

  _updateRest = (
    /** @type {Rest} */ rest,
    /** @type {Number} */ index,
    /** @type {Number} */ column,
    /** @type {Number} */ oldAmount
  ) => {
    RestsService.updateRest(this.props.currentLocalAuthority, rest).then(
      this._updateCellRest.bind(this, index, column, rest),
      this._rejectSaveRest.bind(this, rest, index, column, oldAmount)
    );
  };

  _updateCellRest = (
    /** @type {Number} */ index,
    /** @type {Number} */ column,
    /** @type {Rest} */ rest
  ) => {
    const data = this.state.data;
    data[index][column] = rest;

    if (rest) data[index][column]["loading"] = false;

    this.setState({ data });
  };

  _createResult = (
    /** @type {Result} */ result,
    /** @type {Number} */ index,
    /** @type {String} */ column,
    /** @type {Number} */ oldAmount
  ) => {
    ResultsService.createResult(this.props.currentLocalAuthority, result).then(
      this._updateCellResult.bind(this, index, column, result),
      this._rejectSaveResult.bind(this, result, index, column, oldAmount)
    );
  };

  _deleteResult = (
    /** @type {Result} */ result,
    /** @type {Number} */ index,
    /** @type {String} */ column,
    /** @type {Number} */ oldAmount
  ) => {
    const newResult = new Result(null, null, 0);
    ResultsService.deleteResult(this.props.currentLocalAuthority, result).then(
      this._updateCellResult.bind(this, index, column, newResult),
      this._rejectSaveResult.bind(this, result, index, column, oldAmount)
    );
  };

  _handleCellPressEscape = (
    /** @type {Number} */ index,
    /** @type {String} */ column,
    /** @type {Result} */ result,
    /** @type {SyntheticEvent} */ event
  ) => {
    event.preventDefault();
    const data = this.state.data;
    data[index][column] = result;
    this.setState({ data, focusedCell: null });
  };

  _rejectSaveResult = (
    /** @type {Result} */ result,
    /** @type {Number} */ index,
    /** @type {Number} */ column,
    /** @type {Number} */ oldAmount,
    /** @type {Error} */ error
  ) => {
    result.amount = oldAmount;
    this._updateCellRest(index, column, result);
    this.props.actions.throwError(error);
  };

  _updateResult = (
    /** @type {Result} */ result,
    /** @type {Number} */ index,
    /** @type {Number} */ column,
    /** @type {Number} */ oldAmount
  ) => {
    ResultsService.updateResult(this.props.currentLocalAuthority, result).then(
      this._updateCellResult.bind(this, index, column, result),
      this._rejectSaveResult.bind(this, result, index, column, oldAmount)
    );
  };

  _updateCellResult = (
    /** @type {Number} */ index,
    /** @type {Number} */ column,
    /** @type {Result} */ result
  ) => {
    const data = this.state.data;
    const expense = data[index - 1][column];
    const receipts = data[index - 2][column];

    data[index][column] = result;
    data[index + 1][column] = this._computeInvestmentResult(
      receipts,
      expense,
      result.amount
    );
    data[index][column]["loading"] = false;

    this.setState({ data });
  };

  _computeInvestmentResult = (
    investmentReceipts,
    investmentExpense,
    amount
  ) => {
    amount = amount ? amount : 0;

    return investmentReceipts - investmentExpense + amount;
  };
}

RecapContainer.propTypes = {
  loading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => state;
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(RecapContainer);



// WEBPACK FOOTER //
// ./src/component/summary/investment/recap/recap-container.js